import _ from 'lodash'
import normalize from './normalize'
import formikKey from './formikKey'

export default ({ formikProps: { values }, formikProps, thresholdName }) =>
  normalize(_.get(values, formikKey({ thresholdName, formikProps })))
